import React from 'react';

import block from 'propmods';

import './Typo.scss';

function makeBemEntity<T = object>(blockName: string, elementName?: string) {
    const component: React.FC<React.HTMLProps<HTMLDivElement & T>> = (props) => {
        const b = elementName ? block(blockName)(elementName, props) : block(blockName)(props);

        return <div {...b} {...props} />;
    };

    component.displayName = elementName || blockName;

    return component;
}

export function H2(props: React.HTMLProps<HTMLHeadingElement>) {
    return <h2 {...block('H2')(props)} {...props} />;
}

export function H3(props: React.HTMLProps<HTMLHeadingElement>) {
    return <h3 {...block('H3')(props)} {...props} />;
}

export function Bold(props: React.HTMLProps<HTMLSpanElement>) {
    return <span {...block('Bold')()} {...props} />;
}

interface PageHeadlineProps {
    title: string | React.ReactNode;
    subtitle?: string | React.ReactNode;
}

export function PageHeadline({ title, subtitle }: PageHeadlineProps) {
    const b = block('PageHeadline');

    return (
        <h1 {...b()}>
            <span {...b('title', { alone: !subtitle })}>{title}</span>
            {subtitle && <span {...b('subtitle')}>{subtitle}</span>}
        </h1>
    );
}

export const PageContent = makeBemEntity('PageContent');
export const PageMain = makeBemEntity('PageMain');
export const PageAside = makeBemEntity('PageAside');
export const PageMain2 = makeBemEntity('PageMain2');
export const PageAside2 = makeBemEntity('PageAside2');
export const Page = Object.assign(makeBemEntity('Page'), {
    Head: makeBemEntity('Page', 'head'),
    HeadContent: makeBemEntity('Page', 'head-content'),
    Content: makeBemEntity('Page', 'content'),
    Page: makeBemEntity('Page', 'page'),
});
